import { defineStore } from 'pinia'
import financeiroApi from "@/app/services/financeiro"
import fornecedorsApi from "@/app/services/clientes"

import axios from "@/app/plugins/Axios";

export const usePagamentosStore = defineStore('pagamentos', {
  state: () => ({
    fornecedor: {
      id: null,
    },
    conta_pagar: {},
    contas_pagar: [],
    contas_pagar_em_aberto: [],
    pagamentos: [],
    pagamentos_efetuados: [],
    gerar_haver: false,
    documentos: [],
    tab: 0,

    extrato: {
      contaspagar: [],
      pagamentos: [],
      documentos: [],
      valores: [],
      historico: [],
    },

    btnStatus: {
      contaspagar: 'abertos',
    },
  }),

  getters: {
    somaPagamentos() {
      return this.pagamentos.reduce((soma, pagamento) => soma + Number(pagamento.valor), 0)
    },
    somaContasAPagar(){
      return this.contas_pagar.reduce((soma, conta) => soma + parseFloat(conta.valor), 0)
    },
    somaRestante() {
      return this.contas_pagar.reduce((soma, conta) => soma + Number(conta.valor_restante), 0)
    },
  //   somaPagamentosPromissorias: (state) => {
  //     return state.promissorias.reduce((soma, promissoria) => soma + promissoria.pagamento, 0)
  //   },
    somaSaldo(){
      return this.contas_pagar.reduce((soma, conta) => soma + Number(conta.saldo), 0)
    },
    listaContasEmAberto(){
      return this.contas_pagar_em_aberto.filter(conta => {
        let indice = this.contas_pagar.findIndex(p => {
          return p.documento == conta.documento
        })
        return indice == -1
      })
    }
  },

  actions: {
    adicionarContaPagar(conta_pagar) {
      conta_pagar.pagamento = 0.0
      conta_pagar.saldo = conta_pagar.valor_restante
      this.contas_pagar.push(conta_pagar)
    },

    adicionarPagamento(pagamento) {
      this.pagamentos.push(pagamento)
    },

    removerPagamento(pagamento) {
      let indice = this.pagamentos.indexOf(pagamento)
      if (indice > -1)
        this.pagamentos.splice(indice, 1)
    },

    limparPagamentosContasAPagar() {
      this.contas_pagar = []
      this.pagamentos = []
    },

    setCliente(fornecedor) {
      this.fornecedor = fornecedor
    },

    setPromissoriasEmAberto(promissorias) {
      this.promissoriasEmAberto = promissorias
    },

    removerContaPagar(conta) {
      let indice = this.contas_pagar.findIndex(conta_ => {
        return conta_.id == conta.id
      })
      if (indice > -1)
        this.contas_pagar.splice(indice, 1)
    },

    atualizarPagamentosContasAPagar() {
      let totalPagamentos = this.pagamentos.reduce((soma, pagamento) => soma + Number(pagamento.valor), 0)
      let resto = totalPagamentos

      this.contas_pagar.forEach((conta) => {
        let valorapagar = Number(conta.valor_restante)

        if (resto > valorapagar) {
          conta.pagamento = valorapagar
          conta.saldo = 0
          resto = resto - valorapagar
        } else {
          if (resto > 0) {
            conta.pagamento = resto
            conta.saldo = valorapagar - conta.pagamento
            resto = resto - valorapagar
          } else {
            conta.pagamento = 0
            conta.saldo = valorapagar
            resto = 0
          }
        }
      })
    },

    setGerarHaver(gerar_haver) {
      this.gerar_haver = gerar_haver
    },

    SET_PROMISSORIA(promissoria) {
      this.promissoria = promissoria
    },

    async listarContasPagar() {
      const response = await axios.get(`contaspagar`, {
        params: {
          fornecedor_id: this.fornecedor.id,
          situacao: this.btnStatus.contaspagar,
        },
      });
      this.extrato.contaspagar = response.data;
    },

    async listarContasPagarEmAberto() {
      const response = await axios.get(`contaspagar`, {
        params: {
          fornecedor_id: this.fornecedor.id,
          situacao: 'abertos'
        },
      });
      this.contas_pagar_em_aberto = response.data;
    },

    async finalizarPagamento() {
      try {
        await axios.post(`contaspagar/finalizar-pagamentos`, {
          fornecedor_id: this.fornecedor.id,
          pagamentos: this.pagamentos,
          contas_pagar: this.contas_pagar,
        });
      } catch (error) {
        console.error("Error finalizing receipt:", error);
      } finally {
        // Handle loading state end
      }
    },

    async setClienteById(fornecedor_id) {
      let fornecedor = await fornecedorsApi.abrir(fornecedor_id)
      this.setCliente(fornecedor)
    },

    async carregarPagamentosEfetuados() {
      try {
        const response = await axios.get(`contaspagar/${this.fornecedor.id}/pagamentos`);
        this.extrato.pagamentos = response.data;
      } catch (error) {
        console.error("Error loading payments:", error);
        throw error;
      }
    },

    async pagamentoDocumentos(recebimento_id) {
      try {
        const response = await axios.get(`contaspagar/pagamentos/${recebimento_id}/documentos`);
        this.extrato.documentos = response.data;
      } catch (error) {
        console.error("Error loading payment documents:", error);
        throw error;
      }
    },

    async historicoPagamento(contapagar_id) {
      try {
        const response = await axios.get(`contaspagar/historicopagamento/${contapagar_id}`);
        this.extrato.historico = response.data;
      } catch (error) {
        console.error("Error loading payment history:", error);
        throw error;
      }
    },

    async carregarFornecedor(fornecedor_id) {
      try {
        const response = await axios.get(`fornecedores/${fornecedor_id}`);
        this.fornecedor = response.data;
      } catch (error) {
        console.error("Error loading fornecedor", error);
        throw error;
      }
    },
    abrir(id) {
      return axios.get('/fornecedores/' + id)
        .then(response => response.data);
    }
  }
})
